import {
  Grid,
  Stack,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  TextField,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  IconButton,
  Button
} from '@material-ui/core';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import AddIcon from '@mui/icons-material/Add';
import PropTypes from 'prop-types';
import React from 'react';

VMNetworkSettings.propTypes = {
  currentVM: PropTypes.object,
  updateCurrentVM: PropTypes.func
};

export function VMNetworkSettings({ currentVM, updateCurrentVM }) {
  // remove the interface from the list of interfaces
  const handleRemoveNetworkInterface = (interfaceIndex) => {
    const newVM = { ...currentVM };
    newVM.network.ports.splice(interfaceIndex, 1);
    updateCurrentVM(newVM);
  };

  // add a new interface from the list of interfaces
  const handleAddNetworkInterface = () => {
    const newVM = { ...currentVM };

    // next is the max port number currently on the list
    const next =
      Math.max(...newVM.network.ports.map((i) => Number(i.name.replace('vm-p', '')))) + 1;
    newVM.network.ports.push({ name: `vm-p${next}` });
    updateCurrentVM(newVM);
  };

  return (
    <Grid item xs={12}>
      <Accordion>
        <AccordionSummary sx={{ paddingLeft: 0 }} expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">Network Settings</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Stack direction="column" spacing={2} data-testid="vm-network-settings">
            <Typography value="Network Interfaces" variant="overline">
              Network Interfaces
            </Typography>
            {currentVM.network.ports.map((netInterface, index) => (
              <Grid container xs={12} columnSpacing={2} key={index}>
                <Grid item xs={3}>
                  <TextField label="Port Name" disabled value={netInterface.name} size="small" />
                </Grid>
                <Grid item xs={2}>
                  <FormControl disabled fullWidth size="small">
                    <InputLabel id="size-label">Vlan Mode</InputLabel>
                    <Select label="Vlan Mode" fullWidth size="small">
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={2}>
                  <TextField disabled defaultValue="Vlan Tag" size="small" />
                </Grid>
                <Grid item xs={4}>
                  <FormControl disabled fullWidth size="small">
                    <InputLabel id="size-label">Vlan Trunk Ports</InputLabel>
                    <Select label="Vlan Mode" fullWidth size="small">
                      <MenuItem value="">
                        <em>None</em>
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    data-testid="remove-interface-btn"
                    color="error"
                    onClick={() => handleRemoveNetworkInterface(index)}
                  >
                    <DeleteOutlineOutlinedIcon />
                  </IconButton>
                </Grid>
              </Grid>
            ))}
            <Button
              data-testid="add-network-interface-btn"
              startIcon={<AddIcon />}
              variant="contained"
              sx={{ maxWidth: 220 }}
              onClick={() => handleAddNetworkInterface()}
            >
              Add Network Interface
            </Button>
          </Stack>
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
}
